export default __webpack_public_path__ + "static/media/img2.a1ca0d2b.png";